const exports = {
    /**
     * Finds one object from the store
     * @param {object} store
     * @returns {function} find(keyToMatch, key)
     */
    findOneByKey: (store) => {
        // finds a match between the provided key and the object store
        return (keyToMatch, key) => {
            // returns one match
            return store.find(graduate => {
                return graduate[keyToMatch] === key;
            });
        }
    },
    /**
     * Finds one object from the store
     * @param {object} store
     * @returns {function} find(keysToMatch, key)
     */
    findAllByKey: (store) => {
        // finds a match between the provided keys and the object store
        return (keyToMatch, keys) => {
            let found = [];
            
            keys.forEach(key => {
                let find = store.find(graduate => {
                    return graduate[keyToMatch] === key;
                });
                if (find) {
                    found.push(find);
                }
            });
            // returns a list of found matches
            return found;
        }
    }
};

export default exports;